<template>
    <Component :is="link ? 'a' : 'div'" :href="link" target="_blank" class="overflow-hidden flex items-center justify-center fix-rounding-safari rounded-lg" :class="{relative: overlay}">
        <!-- <iframe
            class="w-full h-full"
            :class="iframe"
            :src="embedLink"
        /> -->
        <MapboxSimple v-if="validCoordinates" :showMarkers="showMarkers" :markers="markers" :zoom="zoom" />
        <div v-if="overlay" @click.stop class="absolute w-full h-full inset-0 bg-black/10 dark:bg-black/30" />
        <slot :link="link" :text="text" />
    </Component>
</template>

<script>
import { defineAsyncComponent } from 'vue'
// Async so mapbox-gl (~1 MB) + geocoder stay out of the entry chunk: the event
// card (components/events/event.vue, on the homepage) imports this file. HAP-4635
const MapboxSimple = defineAsyncComponent(() => import('../layout/mapbox-simple.vue'))

export default {
    components: {MapboxSimple},
    props: {
        address: {required: true},
        zoom: {default: 15, type: Number},
        showMarkers: { type: Boolean, default: true },
        iframe: {type: String},
        overlay: {type: Boolean},
        openMaps: {type: Boolean, default: true},
    },
    computed: {
        validCoordinates() {
            return this.address?.coordinates?.lng && this.address?.coordinates?.lat
        },
        markers() {
            if (!this.validCoordinates) return []
            return [{
                coordinates: [this.address.coordinates.lng, this.address.coordinates.lat],
                id: 'main-marker'
            }]
        },
        embedLink() {
            return `https://www.google.com/maps/embed/v1/place?zoom=${this.zoom}&key=AIzaSyCiZfzTszcY--6-Aiq09uCpQf2kgY4QlWU&q=${this.text}`
        },
        link() {
            if (!this.openMaps) return null
            return `https://www.google.com/maps/search/${this.text}`
        },
        text() {
            let text = `${this.address?.address} ${this.address?.city} ${this.address?.state}`
            if (this.address?.venue) text = `${this.address?.venue} ${text}`
            return text
        }
    }
}
</script>

<style>
.fix-rounding-safari {
    -webkit-mask-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC);
}
</style>
